import VideoHandler from './VideoHandler';

export default VideoHandler;
